'use client';

import type { FC } from 'react';
import type { IDataBanner } from '@/services/isomorphic/ContentService';
import { Link } from '@/react/components/core-ui/Link';

import { isNullish, isNullOrEmpty } from '@/utils/null-utils';
import { ModalLink } from '@/react/components/content/core/ModalLink';
import { classes } from '@/next-utils/css-utils/scss-utils';

import FragmentParser from '@/react/components/utility/FragmentParser';
import S from './styles.base.module.scss';

export interface IInternalBannerProps {
  /**
   * The banner to be rendered.
   */
  banner: IDataBanner;
}

/**
 * Individual banners that can be rendered in a slider.
 */
export const InternalBanner: FC<IInternalBannerProps> = ({ banner }) => {
  const isPopupLink = !isNullOrEmpty(banner.popupID);

  return (
    <div className={S.container} key={banner.text}>
      {!isNullOrEmpty(banner.text) && <FragmentParser string={banner.text} />}
      {isPopupLink ? (
        <ModalLink
          contentID={banner.popupID}
          modalTitle={banner.popupTitle}
          text={banner.link.text}
          className={S.modalLink}
        />
      ) : (
        <>
          {!isNullish(banner.link.link) && !isNullish(banner.link.text) && (
            <Link
              href={banner.link?.link}
              className={classes(!isNullOrEmpty(banner.text) && S.link)}
              variant={banner.link.variant ?? 'text-underline'}
            >
              {banner.link.text}
            </Link>
          )}
        </>
      )}
    </div>
  );
};

export default InternalBanner;
